 /* 
* Author : Sanjeev Kumar Sharma
* Funcitonality : Custom drop down select box
*/
const customDropdown = () => {
    var customSelect = $(".custom-select");

    customSelect.each(function() {
    var thisCustomSelect = $(this),
    selectElement = thisCustomSelect.find('select'),
    options = thisCustomSelect.find("option"),
    firstOptionText = options.first().text();

    var optionValue = thisCustomSelect.find('option:selected').attr('id');
    var optionsSelected = thisCustomSelect.find('option:selected').text();
    
    var selectedItem;
    if (optionsSelected) {
        selectedItem = $('<div></div>', {
            class: 'selected-item',
        })
        .insertAfter(selectElement)
        .html('<span class="option-selected">'+optionsSelected+'</span>');
    } else{
        var selectedItem = $("<div></div>", {
        class: "selected-item"
        })
        .insertAfter(selectElement)
        .text(firstOptionText);
    }

    var allItems = $("<div></div>", {
        class: "all-items all-items-hide"
    }).insertAfter(selectElement);

    options.each(function() {
        var that = $(this),
        optionText = that.text();

        var item = $("<div></div>", {
        class: "item",
        value: that.val(),
        on: {
            click: function() {
                var selectedOptionText = that.text();
                selectedItem.html('<span class="option-selected">'+selectedOptionText+'</span>').removeClass("arrowanim");
                allItems.addClass("all-items-hide");
                let selectId = thisCustomSelect.find('select').attr('id');
                if (that.parents('select.order-history-select').length) {
                    $(`select#${selectId}`).val(that.val());
                    let $ordersContainer = $('.order-list-container');
                    $ordersContainer.empty();
                    $.spinner().start();
                    $('.order-history-select').trigger('orderHistory:sort');
                    $.ajax({
                        url: that.val(),
                        method: 'GET',
                        success: function (data) {
                            $ordersContainer.html(data);
                            $.spinner().stop();
                        },
                        error: function (err) {
                            if (err.responseJSON.redirectUrl) {
                                window.location.href = err.responseJSON.redirectUrl;
                            }
                            $.spinner().stop();
                        }
                    });
                }
                else {
                    $("#"+selectId+" option").removeAttr('selected');
                
                    var id = that[0].id;
                    $("#"+selectId+" option").filter(function(){
                        return this.id === id
                    }).prop('selected', true);  
                }
            }
          }
        })
        .appendTo(allItems)
        .text(optionText);
      });
    });
    var selectedItem = $(".selected-item"),
    allItems = $(".all-items");

    selectedItem.on("click", function(e) {
        var currentSelectedItem = $(this),
        currentAllItems = currentSelectedItem.closest(customSelect).find(".all-items");

        allItems.not(currentAllItems).addClass("all-items-hide");
        selectedItem.not(currentSelectedItem).removeClass("arrowanim");

        currentAllItems.toggleClass("all-items-hide");
        currentSelectedItem.toggleClass("arrowanim");

        e.stopImmediatePropagation();
    });

    $(document).on("click", function() {
        var opened = $(".all-items:not(.all-items-hide)"),
        index = opened.parent().index();
        customSelect
            .eq(index)
            .find(".all-items")
            .addClass("all-items-hide");
        customSelect
            .eq(index)
            .find(".selected-item")
            .removeClass("arrowanim");
    });
}


$(() => {
    customDropdown();
});


module.exports = {
    customDropdown,
};